import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Center.scss'


const Center = ({ children, className, scrollable }) => {

  const rootClassName = cx(s.centringContainer, className, {
    [s.scrollable]: scrollable,
  })

  return (
    <div className={rootClassName}>
      <div className={s.centringContent}>
        {children}
      </div>
    </div>
  )
}

Center.propTypes = {
  children: PropTypes.node,
  scrollable: PropTypes.bool,
}


export default Center
